import React, { createContext, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTitleContext = createContext();

export const PageTitleProvider = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        const pageTitles = {
            '/': 'Tableau de Bord',
            '/verify-user/:userId': 'Vérification de l’Utilisateur',
            '/verify-password/:userId': 'Vérification du Mot de Passe',
            '/request-password-reset': 'Demande de Réinitialisation du Mot de Passe',
            '/profile': 'Profil',
            '/reset-password/:uid/:userId/:token': 'Réinitialisation du Mot de Passe',
            '/dashboard': 'Tableau de Bord',
            '/login': 'Connexion',
            '/register': 'Inscription',
            '/about': 'À Propos',
            '/contact': 'Contactez-Nous',
            '/products/user/:userId/': 'Produits de l’Utilisateur',
            '/products/all': 'Tous les Produits',
            '/products/user-province': 'Produits dans Votre Province',
            '/messages/:userId/': 'Messages',
            '/user/corner/:userId/': 'Boutique de l’Utilisateur',
            '/set-password/:userId': 'Créer un Nouveau Mot de Passe',
            '/forgot-password': 'Mot de Passe Oublié',
            '/user/notifications': 'Notifications',
            '/users/:userId/followers': 'Abonnés',
            '/messages/chatroom/:conversationId/:productId/:userId': 'Salle de Discussion',
            '/messages/chatroom/product/:productId/:userId/:productOwnerId': 'Salle de Discussion',
            '/promote-product/:productId': 'Promouvoir un Produit',
            '/products/category/:categoryId/:categoryName': 'Produits par Catégorie',
            '/search': 'Résultats de Recherche',
            '/add-post': 'Ajouter une Annonce',
            '/portefeuille': 'Mon Portefeuille',
            '/edit-post/:id': 'Modifier une Annonce',
            '/products/view/:id': 'Détails du Produit',
            '/user/:userId': 'Espace Utilisateur',
            '/users/:userId/following': 'Abonnements',
            '/users/discover': 'Découvrir des Utilisateurs',
            '/user/likes/': 'Produits Favoris',
            '/terms-conditions/:title': 'Conditions Générales',
            '/server-down': 'Serveur Indisponible',
            '*': 'Page Introuvable',
        };

        const matchPath = (path, pathname) => {
            if (path === '*') {
                return true; // Match all paths for wildcard
            }

            const paramNames = [];
            const regexPath = path.replace(/:[^\s/]+/g, (match) => {
                paramNames.push(match.substring(1));
                return '([^/]+)';
            });
            const regex = new RegExp(`^${regexPath}$`);
            const match = pathname.match(regex);
            if (!match) return null;
            const params = match.slice(1).reduce((acc, value, index) => {
                acc[paramNames[index]] = value;
                return acc;
            }, {});
            return { path, params };
        };

        const pageTitle = Object.keys(pageTitles).find((path) => {
            const result = matchPath(path, location.pathname);
            return result;
        });

        document.title = `Wennze | ${pageTitles[pageTitle] || 'Page'}`;
    }, [location]);

    return (
        <PageTitleContext.Provider value={{}}>
            {children}
        </PageTitleContext.Provider>
    );
};

export const usePageTitle = () => useContext(PageTitleContext);